/*eslint-env browser */
import * as React from 'react'
import cx from 'classnames'
import styles from './busy.line.styl'
import NProgress from 'nprogress'
import 'nprogress/css/nprogress.css'
import GlobalEvents from '@src/utils/custom.event'
import { MAKE_REQUEST_PENDING } from '@src/constants/events'

interface OwnProps {}
export type Props = OwnProps

type HandleBusyLineEvent =
  | CustomEvent<{ isPending: boolean }>
  | (Event & { detail?: { isPending: boolean } })

const BusyLine: React.FC<Props> = (props: Props) => {
  if (NProgress) {
    NProgress.configure({
      minimum: 0.01,
      parent: '#busyLine',
      speed: 600,
      easing: 'ease',
      trickleSpeed: 800,
      showSpinner: false
    })
  }

  function handleBusyLine(e: HandleBusyLineEvent) {
    const isPending = e.detail.isPending
    if (NProgress) {
      if (isPending) NProgress.start()
      else {
        NProgress.set(0.8).done(true)
      }
    }
  }

  React.useEffect(() => {
    GlobalEvents.on(MAKE_REQUEST_PENDING, handleBusyLine)
    return () => {
      GlobalEvents.off(MAKE_REQUEST_PENDING)
      if (NProgress) {
        NProgress.done()
        NProgress.remove()
      }
    }
  }, [])

  return (
    <div className={cx(styles.uiProgress)}>
      <div id={'busyLine'} className={cx('progressBar', styles.progressBar)} />
    </div>
  )
}

export default BusyLine
